module.exports = __webpack_public_path__ + "img/Retur.438bdf3b.svg";